module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._v("\n  Dashboard content will go here\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc421d0e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/containers/dashboard.vue
// module id = 35
// module chunks = 1